import router from "./router";
import store from "./store";
import { getToken } from "@/utils/auth";
// 不带id的路由列表
const noIdList = [
  "/login",
  "/welcome",
  "/owner-member-manage",
  "/main-device-log",
  "/community-activity-check",
  "/dict-data",
  "/addQuestionnaire",
  "/money-daily-return",
];

// 白名单
const whiteList = ["/login"];
//登录TOKEN判断限制
router.beforeEach((to, from, next) => {
  if (to.query.shortCut == "true" || to.query.jumpTodo) {
    next();
    return;
  }
  if (!to.query.id && !noIdList.includes(to.path)) {
    next("/");
  } else if (getToken()) {
    store.dispatch("global/getAllGlobalData");

    // 判断打开新的页面、Vuex中没有值
    if (store.getters["utils/routerList"]?.length == 0) {
      store
        .dispatch("utils/getUserInfo", {
          initSocket: true,
        })
        .then((res) => {
          if (res) {
            if (to.path === "/login") {
              next({
                path: from.path,
                query: from.query,
              });
            } else {
              // if (!store.state.global.isFirst) {
              //   store.dispatch("global/getAllGlobalData")
              //   store.commit("global/SET_IS_FIRST", true)
              // }
              next();
            }
          }
        });
    } else {
      if (to.path === "/login") {
        next({
          path: from.path,
          query: from.query,
        });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.includes(to.path)) {
      // 在免登录白名单重的页面可以直接进入
      next();
    } else {
      // 不在白名单中的页面必须先登录再进入
      next("/login");
    }
  }
});
